import { Instance, flow, types } from 'mobx-state-tree'
import { fetchPayoutLinksList } from '../../network/payoutLinks'
import { getSelectedDate } from '../../util/util'
import { paginationSettingsWithDefaultPage1 } from '../static/data'
import { RootStore } from '../store'

const Position = types.model('position', {
  left: types.number,
  top: types.number,
  visible: types.boolean,
})
const DateRange = types.model('date', {
  fromDate: types.Date,
  toDate: types.Date,
  position: Position,
  dateLabel: types.optional(types.string, ''),
})

const Pagination = types.model('Pagination', {
  size: types.optional(types.number, 0),
  totalElements: types.optional(types.number, 0),
  totalPages: types.optional(types.number, 0),
  number: types.optional(types.number, 0),
})
const PayoutLink = types.model('PayoutLink', {
  date: types.maybeNull(types.string),
  id: types.maybeNull(types.string),
  amount: types.maybeNull(types.string),
  invoiceNo: types.maybeNull(types.string),
  beneficiaryName: types.maybeNull(types.string),
  method: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
})

const PayoutLinks = types
  .model('PayoutLinks', {
    list: types.array(PayoutLink),
    selectedDate: DateRange,
    pagination: Pagination,
  })
  .actions((self) => ({
    fetchPayoutLinks: flow(function* fetchPayoutLinks(mid: string) {
      let response
      try {
        response = yield fetchPayoutLinksList(mid, RootStore.user.session.getTokens)
        self.list = response
      } catch (e) {
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),
  }))
  .views((self) => ({}))

export type PayoutLinksType = Instance<typeof PayoutLinks>
export { PayoutLink, PayoutLinks }

export const PayoutLinksData = PayoutLinks.create({
  list: [
    {
      date: '',
      id: '',
      amount: '',
      invoiceNo: '',
      beneficiaryName: '',
      method: '',
      status: '',
    },
    {
      date: '',
      id: '',
      amount: '',
      invoiceNo: '',
      beneficiaryName: '',
      method: '',
      status: '',
    },
  ],
  selectedDate: {
    fromDate: getSelectedDate(1),
    toDate: new Date(Date.now()),
    dateLabel: 'Today',
    position: {
      top: 0,
      left: 0,
      visible: false,
    },
  },
  pagination: paginationSettingsWithDefaultPage1,
})
